import React from 'react';
import {NetworkFilter} from 'domain/usecases/private/guide-flow/medical-guide/get-network-filters';
import {GuideFilterEnum} from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';
import {textHandle} from 'presentation/utils/textHandle';
import {AutocompleteSelect} from '../SearchDetails/AutocompleteSelect';
import {SkeletonInput} from '../SkeletonInput';
import {useNetworkInput} from './hooks/useNetworkInput';
import {NetworkInputProps} from './types';

const {selectNetwork} = translations['pt-br'].privateFlow.guideFlow;

export function NetworkInput({networkFilters = [], isLoading}: NetworkInputProps) {
	const {availableOptions, isDisabled, selectedDescription, handleChange, serviceType} =
		useNetworkInput({
			networkFilters,
			isLoading,
		});

	if (isLoading && serviceType) {
		return (
			<SkeletonInput label={translations['pt-br'].privateFlow.guideFlow.loadingNetworks} />
		);
	}

	return (
		<AutocompleteSelect
			dataTagId={GuideFilterEnum.APLICOU_FILTRO_TIPO_REDE}
			key={serviceType}
			disabled={isDisabled}
			customPlaceholder={selectNetwork}
			value={selectedDescription()}
			onValueChange={handleChange}
			options={availableOptions}
			getOptionLabel={(opt: NetworkFilter) =>
				textHandle(opt.descricao).capitalizeFirstLetter()
			}
			getOptionValue={(opt: NetworkFilter) => opt.descricao.toUpperCase()}
			loading={false}
		/>
	);
}
